export * from './cashier-trans-cover.component';